// Catálogo y ficha de vehículos (listado, filtros, tarjetas, orden, ficha, galería) y valores de catálogo de la base — Español.
//
// Existe en es, pt y en (mismas claves; `npm run test:i18n-en-paridad` lo verifica).
// Estos textos estaban fijos en español en el código: cada valor de acá tiene que
// ser IDÉNTICO al literal que reemplaza.
//
// `values`: etiquetas de los VALORES de catálogo que vienen de la base en español
// (condición, combustible, transmisión, categoría, color). Sólo se consultan en
// sitios de Brasil (ver `etiquetaCatalogoPt` en `@/utils/functions`); un sitio
// chileno sigue mostrando el valor de la base tal cual, como siempre. La clave es
// el valor normalizado (minúsculas, sin tildes, separadores → `_`). Los valores en
// español están por paridad de claves con pt/catalog.ts.
export const catalogEs = {
  common: {
    vehicle: 'Vehículo',
  },
  listing: {
    loadMore: 'Ver más vehículos',
    viewAll: 'Ver todos los vehículos',
    clearSearch: 'Limpiar búsqueda',
  },
  search: {
    tip: 'Prueba: "bajo 15 millones", "no diesel", "con sunroof"',
    noResultsFor: 'No encontramos vehículos para "{{query}}"',
    didYouMean: '¿Quisiste decir?',
    tipsTitle: 'Tips de búsqueda inteligente',
    tipPrice: '"bajo 15 millones"',
    tipPriceDesc: ' - Filtra por precio máximo',
    tipYear: '"2020 o más nuevo"',
    tipYearDesc: ' - Filtra por año mínimo',
    tipFuel: '"no diesel"',
    tipFuelDesc: ' - Excluye un tipo de combustible',
    tipFeature: '"con sunroof"',
    tipFeatureDesc: ' - Busca por características',
  },
  filters: {
    expand: 'Expandir filtros',
    collapse: 'Colapsar filtros',
    priceRangeAria: 'Rango de precio',
    yearFrom: 'Desde',
    yearTo: 'Hasta',
    anyYear: 'Cualquiera',
  },
  promo: {
    limitedTime: 'Tiempo limitado',
    countOne: 'auto en promoción',
    countMany: 'autos en promoción',
  },
  card: {
    new: 'Nuevo',
    recentArrival: 'Recién llegado',
    opportunity: 'Oportunidad',
    featured: 'Destacado',
    save: 'Ahorra',
    cashPrice: 'Precio contado',
    financingPrice: 'Precio financiamiento',
  },
  detail: {
    viewGallery: 'Ver toda la galería',
    shareText: 'Mira este {{title}}',
    linkCopied: '¡Enlace copiado!',
    copyError: 'Error al copiar',
    whatsappMessage: 'Hola, me interesa el {{vehicle}} que vi en {{url}}',
    availableAt: 'Disponible en sucursal',
    directions: 'Cómo llegar',
    unsave: 'Quitar de guardados',
  },
  gallery: {
    close: 'Cerrar',
    previous: 'Anterior',
    next: 'Siguiente',
    exitZoom: 'Salir del zoom',
  },
  values: {
    condition: {
      nuevo: 'Nuevo',
      semi_nuevo: 'Semi-nuevo',
      seminuevo: 'Seminuevo',
      usado: 'Usado',
    },
    fuel: {
      gasolina: 'Gasolina',
      bencina: 'Bencina',
      diesel: 'Diésel',
      hibrido: 'Híbrido',
      electrico: 'Eléctrico',
      flex: 'Flex',
      gnv: 'GNV',
      etanol: 'Etanol',
      gas: 'Gas',
    },
    transmission: {
      manual: 'Manual',
      automatica: 'Automática',
    },
    category: {
      suv: 'SUV',
      sedan: 'Sedán',
      camioneta: 'Camioneta',
      deportivo: 'Deportivo',
      clasico: 'Clásico',
      coupe: 'Coupé',
      furgon: 'Furgón',
      camion_rigido: 'Camión Rígido',
      tractocamion: 'Tractocamión',
      camion_tolva: 'Camión Tolva',
      camion_pluma: 'Camión Pluma',
      camion_cisterna: 'Camión Cisterna',
      camion_frigorifico: 'Camión Frigorífico',
      camion_plataforma: 'Camión Plataforma',
      camion_portacontenedores: 'Camión Portacontenedores',
      bus: 'Bus',
      minibus: 'Minibús',
      excavadora: 'Excavadora',
      retroexcavadora: 'Retroexcavadora',
      cargador_frontal: 'Cargador Frontal',
      bulldozer: 'Bulldozer',
      hatchback: 'Hatchback',
      motoniveladora: 'Motoniveladora',
      rodillo_compactador: 'Rodillo Compactador',
      minicargador: 'Minicargador',
      mini_excavadora: 'Mini Excavadora',
      grua: 'Grúa',
      manipulador_telescopico: 'Manipulador Telescópico',
      tractor_agricola: 'Tractor Agrícola',
      cosechadora: 'Cosechadora',
      camion_articulado: 'Camión Articulado',
      generador: 'Generador',
      pickup: 'Pickup',
      compresor: 'Compresor',
      montacargas: 'Montacargas',
      plataforma_elevadora: 'Plataforma Elevadora',
      lancha: 'Lancha',
      moto_de_agua: 'Moto de Agua',
      velero: 'Velero',
      yate: 'Yate',
      bote_inflable: 'Bote Inflable',
      semirrigido: 'Semirrígido',
      ponton: 'Pontón',
      van: 'Van',
      crucero: 'Crucero',
      catamaran: 'Catamarán',
      kayak: 'Kayak',
      motor_fuera_de_borda: 'Motor Fuera de Borda',
      lancha_de_pesca: 'Lancha de Pesca',
      city_car: 'City Car',
      minivan: 'Minivan',
      station_wagon: 'Station Wagon',
      crossover: 'Crossover',
      moto: 'Moto',
      automovil: 'Automóvil',
      camion: 'Camión',
      micro_bus: 'Micro bus',
      cabezal: 'Cabezal',
      limusina: 'Limusina',
      buggy: 'Buggy',
      motorhome: 'Motorhome',
      ambulancia: 'Ambulancia',
      cuatriciclo: 'Cuatriciclo',
      triciclo: 'Triciclo',
      wagon: 'Wagon',
      kart: 'Kart',
      bote: 'Bote',
      jet_ski: 'Jet Ski',
      maquinaria: 'Maquinaria',
      otro: 'Otro',
      vehiculos_de_trabajo: 'Vehículos de trabajo',
      moto_atv_y_utv: 'Moto, ATV y UTV',
      convertible: 'Convertible',
    },
    color: {
      amarillo: 'Amarillo',
      azul: 'Azul',
      azul_oscuro: 'Azul Oscuro',
      beige: 'Beige',
      blanco: 'Blanco',
      borgona: 'Borgoña',
      burdeo: 'Burdeo',
      cafe: 'Café',
      celeste: 'Celeste',
      cobre: 'Cobre',
      dorado: 'Dorado',
      gris: 'Gris',
      gris_claro: 'Gris claro',
      gris_oscuro: 'Gris oscuro',
      gris_plata: 'Gris Plata',
      morado: 'Morado',
      naranja: 'Naranja',
      naranjo: 'Naranjo',
      negro: 'Negro',
      plata: 'Plata',
      plateado: 'Plateado',
      rojo: 'Rojo',
      rosado: 'Rosado',
      terracota: 'Terracota',
      turquesa: 'Turquesa',
      verde: 'Verde',
      verde_claro: 'Verde claro',
      verde_oscuro: 'Verde oscuro',
      violeta: 'Violeta',
    },
  },
};
